import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Spacer, PageDS, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { DepositTab } from "./deposit";
import { InvoiceTab } from "./invoice";
import { PricingTab } from "./pricing";
import { AsfInvoiceTab } from "./asfInvoice";
import "../../i18n/i18n";
import { useAppSelector } from "../../redux/hooks";
import { selectAdminUser } from "../homeSlice";

export const Billings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const adminUser = useAppSelector(selectAdminUser);
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "deposits",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/home/billings/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  const tabs = [
    {
      name: "deposits",
      title: t("billings.tab.deposits"),
    },
    {
      name: "pricings",
      title: t("billings.tab.pricings"),
    },
    {
      name: "invoices",
      title: t("billings.tab.invoices"),
    },
    {
      name: "asfInvoices",
      title: t("billings.tab.asfInvoices"),
    },
  ];

  if (adminUser?.email === "exterieur1@qivia.fr") {
    navigate("/home");
  }

  return (
    <PageDS
      title={t(`billings.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <DepositTab />
      <InvoiceTab />
      <AsfInvoiceTab />
      <PricingTab />
    </PageDS>
  );
};
